export const getSpeedUnitKey = (unit = 'metric') => `COMMON.UNITS.${unit === 'imperial' ? 'IMPERIAL' : 'METRIC'}.SPEED`;
export const cleanSpeed = (value = 0, precision = 0) => parseFloat(value).toFixed(precision).replace(/\.0+$/, '');
